<script>
import {mapState} from 'vuex';
export default {
    props: {
        verified: {
            type: Boolean,
            default: false
        }
    },
    data : () => ({
        loginModal : false,
        subastaloUrl: process.env.MIX_SUBASTALO_URL,
        miAutoDealUrl: process.env.MIX_MI_AUTO_DEAL_URL
    }),
    methods : {
        showLogin() {
            this.loginModal = true;
            const el = document.body;
            el.classList.add('overflow-hidden');
        },
        closeModal(){
            this.loginModal = false;
            const el = document.body;
            el.classList.remove('overflow-hidden');
        },
        logout() {
            axios.post('logout')
        }
    },
    computed : {
        ...mapState(['user']),
        authCheck() { return this.user !== ""; },
    }
}
</script>
<template>
    <div style="display: flex;">
        <div class="my-car-sale  tx-10 sm:tx-12 md:pr-10 pr-3">
            <a :href="miAutoDealUrl" target="_blank" class="btn btn--green-ad btn-sell btn--nav-ad mb-3 py-2 px-2 md:mt-3 my-0"
            style="width: max-content ">Soy una agencia
            </a>
        </div>
        <div class="my-car-sale  tx-10 sm:tx-12 pr-0">
            <a :href="subastaloUrl" target="_blank" class="btn btn--green-ad btn-sell btn--nav-ad mb-3 py-2 px-2 md:mt-3 my-0"
            style="width: max-content ">Vender mi auto
            </a>
        </div> 
    </div>
    
</template>
<style lang="css">
/*     @media (max-width: 542px) {
        .my-car-sale {
            max-width: 50%;
            flex: 0 0 28%;
        }
    } */

    @media (max-width: 420px) {
        .my-car-sale > .btn--green-ad {
            font-size: calc(0.5vw + 6px);
        }
    }

</style>
